import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { fetchAvailableEndTimes, fetchAvailableStartTimes, fetchMeetingRooms } from "@features/reservation/api/meeting";
import { fetchRemainingMinutes } from "@features/reservation/api/remainingMinutes";
import { fetchReservations } from "@features/reservation/api/reserve";

/**
 * reservation 도메인 쿼리 팩토리.
 */
export const reservationQueries = {
  all: () => ["reservation"] as const,
  meetingRoomsKey: (dateStr: string) => [...reservationQueries.all(), "meetingRooms", dateStr] as const,
  availableStartTimesKey: (roomId: number, dateStr: string) =>
    [...reservationQueries.all(), "availableStartTimes", roomId, dateStr] as const,
  availableEndTimesKey: (roomId: number, dateStr: string, startTime: string) =>
    [...reservationQueries.all(), "availableEndTimes", roomId, dateStr, startTime] as const,
  reservationsKey: (year: number, month: number) => [...reservationQueries.all(), "reservations", year, month] as const,
  remainingMinutesKey: () => [...reservationQueries.all(), "remainingMinutes"] as const,

  meetingRooms: (dateStr: string) =>
    queryOptions({
      queryKey: reservationQueries.meetingRoomsKey(dateStr),
      queryFn: () => fetchMeetingRooms(dateStr),
      staleTime: 0,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      placeholderData: keepPreviousData,
    }),

  availableStartTimes: (roomId: number, dateStr: string) =>
    queryOptions({
      queryKey: reservationQueries.availableStartTimesKey(roomId, dateStr),
      queryFn: () => fetchAvailableStartTimes(roomId, dateStr),
      staleTime: 0,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      enabled: !!dateStr && !!roomId,
    }),

  availableEndTimes: (roomId: number, dateStr: string, startTime: string) =>
    queryOptions({
      queryKey: reservationQueries.availableEndTimesKey(roomId, dateStr, startTime),
      queryFn: () => fetchAvailableEndTimes(roomId, dateStr, startTime),
      staleTime: 0,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      enabled: !!dateStr && !!roomId && !!startTime,
    }),

  reservations: (year: number, month: number) =>
    queryOptions({
      queryKey: reservationQueries.reservationsKey(year, month),
      queryFn: () => fetchReservations(year, month),
      staleTime: 0,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: true,
    }),

  remainingMinutes: () =>
    queryOptions({
      queryKey: reservationQueries.remainingMinutesKey(),
      queryFn: fetchRemainingMinutes,
      staleTime: 0,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    }),
};
